import {
  MODEL__NAME__ACCOUNT
} from '../../dictionaries/Models.dic';
import {
  Arr
} from '../Array.lib';
import {
  YES
} from '../Boolean.lib';
import Core from '../Core';
import {
  Obj
} from '../Object.lib';

/**
 * Maps starred value and starredId to an entity (Account, Candidate, Employer, Job, Engagement)
 * @function mapStarred
 * @param {Object} options
 * @param {Object} options.model - entity to map properties to
 * @param {Array} options.starredList - array of starred records with following properties:
 *   {
 *     id: string,
 *     starred: boolean,
 *     [accountId]: string, // userId if entity is Account and accountId if entity is not Account
 *     [entityId]: string, // candidateId or employerId or jobId or engagementId or accountId (useless for this case)
 *   }
 * @returns {Object} entity with starred and starredId properties
 */
export default function mapStarred({ model: entity, starredList = [] }) {

  // STARRED RECORD, first element in the list, this assumes it is the only one starred record by the current user
  const starredRecord = Obj(
    Arr(starredList).filter(
      (record) => (
        entity.___model___ === MODEL__NAME__ACCOUNT
          ? record.userId === Core.getUserId()
          : record.accountId === Core.getUserId()
      )
    )[0]
  );

  // STARRED ID (string)
  entity.starredId = starredRecord.id;
  
  // STARRED FLAG (boolean)
  entity.starred = YES(starredRecord.starred);
  
  // console.debug('mapStarred', entity, starredList, Core.getUserId(), starredRecord);

  return entity;
}
